const RouterComponent = () => import('@/views/Router/RouterView')

export default [
    {
        path:'/RouterIndex',
        name:'RouterRouter',
        component:RouterComponent
    }
]